// src/pages/Mission.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Mission.css";

// If you already have a hero image, use it.
// Otherwise reuse your existing hero city.
import heroImg from "../assets/hero_city.jpg";
import Img from "../assets/pexels-marina-hinic-199169-726233.jpg"

// Your mini game component
import WParkTrafficDemo from "../components/WParkTrafficDemo";

export default function Mission() {
  return (
    <main className="ms">
      {/* HERO */}
      <section className="msHero" aria-label="Mission hero">
        <div className="msContainer">
          <div className="msHero__frame">
            <img className="msHero__img" src={Img} alt="" />
            <div className="msHero__overlay" />

            <div className="msHero__content">
              <div className="msHero__kicker">WPARK</div>

              <h1 className="msHero__title">OUR MISSION</h1>

              <p className="msHero__sub">
                Autonomy is becoming part of daily life. Today, it still needs guidance.
                Safety and efficiency demand independent control — a system that
                orchestrates movement across real-world sites.
              </p>

              <div className="msHero__cta">
                <Link className="msBtn" to="/product">
                  View product →
                </Link>
                <a className="msBtn msBtn--ghost" href="mailto:hello@thewpark.com">
                  Request a demo →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTENT: Video + Mission narrative */}
      <section className="msSection" aria-label="Mission narrative">
        <div className="msContainer">
          <div className="msGrid">
            {/* Left: Vertical video column */}
            <aside className="msLeft">
              <div className="msMini">ONE MINUTE</div>

              <div className="msVideoCard" aria-label="WPark intro video">
                <div className="msVideoCard__top">
                  <div className="msVideoCard__title">WPARK TEAM INTRO</div>
                  <div className="msVideoCard__meta">1 min · vertical</div>
                </div>

                <div className="msVideoFrame">
                  <iframe
                    src="https://www.youtube.com/embed/0xz1XvDxbYc"
                    title="WPark Team Intro"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>

                <div className="msVideoCard__note">
                  Illustrative overview of our approach to orchestration.
                </div>
              </div>
            </aside>

            {/* Right: Mission text */}
            <article className="msRight">
              <div className="msMini">MISSION</div>

              <h2 className="msH2">
                From uncertainty to certainty — for real-world movement.
              </h2>

              <div className="msCopy">
                <p>
                  Autonomy does not fail in isolation — it fails in shared environments:
                  dense sites, mixed fleets, inconsistent rules, live disruptions.
                </p>

                <p>
                  WPark builds an <strong>independent traffic control layer</strong> for ground
                  mobility — a Universal Traffic Controller that can understand, reason
                  about, and coordinate movement at machine speed.
                </p>

                <p>
                  We start where the complexity is most measurable:{" "}
                  <strong>parking, depots, ports, and logistics yards</strong>. Then we scale
                  to broader urban flow.
                </p>
              </div>

              <div className="msCards">
                <div className="msCard">
                  <div className="msCard__title">Safety</div>
                  <div className="msCard__text">
                    Clear sequencing, right-of-way logic, and site rules enforced consistently.
                  </div>
                </div>

                <div className="msCard">
                  <div className="msCard__title">Efficiency</div>
                  <div className="msCard__text">
                    Reduce dwell time and congestion by orchestrating priorities in real time.
                  </div>
                </div>

                <div className="msCard">
                  <div className="msCard__title">Interoperability</div>
                  <div className="msCard__text">
                    A control plane that supports drivers, self-driving systems, and OEM integration.
                  </div>
                </div>
              </div>

              <div className="msDivider" />

              <div className="msMini">HOW WE THINK</div>
              <h3 className="msH3">Tactical autonomy needs strategic coordination.</h3>
              <p className="msCopy msCopy--tight">
                Vehicles execute. The system orchestrates. Like air-traffic control, we maintain
                continuity, memory, and sequencing — so movement remains safe and predictable
                under real-world disruption.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* MINI GAME / DEMO */}
      <section className="msSection" aria-label="Interactive demo">
        <div className="msContainer">
          <div className="msDemoTop">
            <div className="msMini">INTERACTIVE</div>
            <h2 className="msH2">Try the traffic orchestration demo.</h2>
            <p className="msLead">
              A simple simulation showing how routing + sequencing changes flow under constraints.
            </p>
          </div>

          <div className="msDemoFrame">
            <WParkTrafficDemo />
          </div>

          <div className="msDemoBottom">
            <Link className="msBtn msBtn--ghost" to="/product">
              Explore UTC capabilities →
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}